// SPDX-License-Identifier: AGPL-3.0-or-later

function getBootstrapProductName(): string {
	if (typeof window === 'undefined') {
		return 'LafON';
	}
	const productName = window.__FLUXER_BOOTSTRAP__?.instance.app_public?.branding?.product_name?.trim();
	return productName || 'LafON';
}

export const PRODUCT_NAME = getBootstrapProductName();
/** Paid subscription tier (formerly Plutonium). */
export const PREMIUM_PRODUCT_NAME = 'Lafon Pro';
export const PREMIUM_PRODUCT_FULL_NAME = PREMIUM_PRODUCT_NAME;
/** Lifetime / VIP tier (formerly Visionary). */
export const VIP_PRODUCT_NAME = 'Lafon Prime';
